<app-side-menu>
  <div class="staff-form-container" [class.editing]="isEditing">
    <div class="form-header">
      <div class="header-content">
        <div class="header-left">
          <h1>
            <i [class]="isEditing ? 'fas fa-user-edit' : 'fas fa-user'"></i> 
            {{ isEditing ? 'Editar' : 'Visualizar' }} Funcionário
          </h1>
          <p>{{ isEditing ? 'Edite as informações do funcionário' : 'Visualize as informações do funcionário' }} {{ staffName }}</p>
        </div>
        
        <div class="header-actions">
          <!-- Botão Editar - só aparece no modo visualização -->
          <button *ngIf="!isEditing" 
                  class="btn btn-primary" 
                  (click)="startEditing()" 
                  type="button">
            <i class="fas fa-edit"></i>
            Editar
          </button>
          
          <!-- Botão Fechar - sempre visível -->
          <button class="btn btn-secondary" 
                  (click)="goBack()" 
                  type="button">
            <i class="fas fa-times"></i>
            Fechar
          </button>
        </div>
      </div>
    </div>

    <!-- Mensagem de Sucesso -->
    <div *ngIf="successMessage" class="success-message">
      <i class="fas fa-check-circle"></i>
      <span>{{ successMessage }}</span>
      <button class="close-btn" (click)="clearSuccess()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Mensagem de Erro -->
    <div *ngIf="error" class="error-message">
      <i class="fas fa-exclamation-circle"></i>
      <span>{{ error }}</span>
      <button class="close-btn" (click)="clearError()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <app-form-shell
      [tabs]="availableTabs"
      [activeTab]="activeTab"
      (tabChange)="selectTab($event)">

      <!-- Conteúdo das Abas -->
      <div class="tab-content">
        
        <!-- Aba: Informações Básicas -->
        <div *ngIf="activeTab === 'basic'" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-user"></i> Dados Pessoais</h3>
            <div class="detail-grid">
              <!-- Nome Completo - Largura total -->
              <div class="detail-item full-width">
                <label>Nome Completo:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.FullName || '-' }}
                </div>
                <input *ngIf="isEditing" 
                       type="text" 
                       [value]="editData?.staff?.fullName || ''" 
                       (input)="updateField('staff', 'fullName', getInputValue($event))"
                       placeholder="Digite o nome completo" 
                       required>
              </div>

              <!-- Primeira linha: Estrangeiro e CPF/Passaporte -->
              <div class="detail-item">
                <label>É Estrangeiro?</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.IsForeigner ? 'Sim' : 'Não' }}
                </div>
                <input *ngIf="isEditing" 
                       type="checkbox" 
                       [checked]="editData?.staff?.isForeigner || false" 
                       (change)="updateField('staff', 'isForeigner', getCheckboxValue($event))">
              </div>

              <div class="detail-item" *ngIf="!(staffComplete?.Staff?.IsForeigner || editData?.staff?.isForeigner)">
                <label>CPF:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ applyCpfMask(staffComplete?.Staff?.CPF || '') }}
                </div>
                <input *ngIf="isEditing" 
                       type="text" 
                       [value]="applyCpfMask(editData?.staff?.cpf || '')" 
                       (input)="updateField('staff', 'cpf', removeCpfMask(getInputValue($event)))"
                       placeholder="000.000.000-00" 
                       maxlength="14"
                       required>
              </div>
              
              <div class="detail-item" *ngIf="staffComplete?.Staff?.IsForeigner || editData?.staff?.isForeigner">
                <label>Número do Passaporte:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.PassportNumber || '-' }}
                </div>
                <input *ngIf="isEditing" 
                       type="text" 
                       [value]="editData?.staff?.passportNumber || ''" 
                       (input)="updateField('staff', 'passportNumber', getInputValue($event))"
                       placeholder="Digite o número do passaporte" 
                       required>
              </div>

              <!-- Segunda linha: RG e Órgão Expedidor -->
              <div class="detail-item">
                <label>RG:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.RG || '-' }}
                </div>
                <input *ngIf="isEditing" 
                       type="text" 
                       [value]="editData?.staff?.rg || ''" 
                       (input)="updateField('staff', 'rg', getInputValue($event))"
                       placeholder="Ex: 12.345.678-9 ou 12.345.678-9 SP" 
                       maxlength="20">
              </div>

              <div class="detail-item">
                <label>Órgão Expedidor RG:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.RGIssuingAuthority || '-' }}
                </div>
                <input *ngIf="isEditing" 
                       type="text" 
                       [value]="editData?.staff?.rgIssuingAuthority || ''" 
                       (input)="updateField('staff', 'rgIssuingAuthority', getInputValue($event))"
                       placeholder="Ex: SSP, DETRAN">
              </div>

              <!-- Terceira linha: Data de Emissão RG e Data de Nascimento -->
              <div class="detail-item">
                <label>Data de Emissão RG:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ formatDate(staffComplete?.Staff?.RGIssueDate || null) }}
                </div>
                <input *ngIf="isEditing" 
                       type="date" 
                       [value]="getRgIssueDateForInput()" 
                       (change)="updateField('staff', 'rgIssueDate', getInputValue($event))">
              </div>

              <div class="detail-item">
                <label>Data de Nascimento:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ formatDate(staffComplete?.Staff?.BirthDate || null) }}
                </div>
                <input *ngIf="isEditing" 
                       type="date" 
                       [value]="getBirthDateForInput()" 
                       (change)="updateField('staff', 'birthDate', getInputValue($event))" 
                       required>
              </div>

              <!-- Quarta linha: Gênero e Estado Civil -->
              <div class="detail-item">
                <label>Gênero:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ mapEnumValue('gender', staffComplete?.Staff?.Gender || null) }}
                </div>
                <select *ngIf="isEditing" 
                        [value]="editData?.staff?.gender || 'M'" 
                        (change)="updateField('staff', 'gender', getSelectValue($event))" 
                        required>
                  <option value="M">Masculino</option>
                  <option value="F">Feminino</option>
                  <option value="N">Não informado</option>
                </select>
              </div>

              <div class="detail-item">
                <label>Estado Civil:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ mapEnumValue('maritalStatus', staffComplete?.Staff?.MaritalStatus || null) }}
                </div>
                <select *ngIf="isEditing" 
                        [value]="editData?.staff?.maritalStatus || 'Solteiro'" 
                        (change)="updateField('staff', 'maritalStatus', getSelectValue($event))" 
                        required>
                  <option value="Solteiro">Solteiro</option>
                  <option value="Casado">Casado</option>
                  <option value="Divorciado">Divorciado</option>
                  <option value="Viúvo">Viúvo</option>
                </select>
              </div>

              <!-- Quinta linha: Nome da Mãe e Nome do Pai -->
              <div class="detail-item">
                <label>Nome da Mãe:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.MotherName || '-' }}
                </div>
                <input *ngIf="isEditing" 
                       type="text" 
                       [value]="editData?.staff?.motherName || ''" 
                       (input)="updateField('staff', 'motherName', getInputValue($event))"
                       placeholder="Digite o nome da mãe" 
                       required>
              </div>

              <div class="detail-item">
                <label>Nome do Pai:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.FatherName || '-' }}
                </div>
                <input *ngIf="isEditing" 
                       type="text" 
                       [value]="editData?.staff?.fatherName || ''" 
                       (input)="updateField('staff', 'fatherName', getInputValue($event))"
                       placeholder="Digite o nome do pai">
              </div>

              <!-- Sexta linha: Nacionalidade e Naturalidade -->
              <div class="detail-item">
                <label>Nacionalidade:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.Nationality || '-' }}
                </div>
                <input *ngIf="isEditing" 
                       type="text" 
                       [value]="editData?.staff?.nationality || ''" 
                       (input)="updateField('staff', 'nationality', getInputValue($event))"
                       placeholder="Ex: Brasileira" 
                       required>
              </div>
              
              <div class="detail-item">
                <label>Naturalidade:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.BirthPlace || '-' }}
                </div>
                <input *ngIf="isEditing" 
                       type="text" 
                       [value]="editData?.staff?.birthPlace || ''" 
                       (input)="updateField('staff', 'birthPlace', getInputValue($event))"
                       placeholder="Cidade de nascimento" 
                       required>
              </div>

              <!-- Sétima linha: Possui Deficiência -->
              <div class="detail-item">
                <label>Possui Deficiência?</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.HasDisability ? 'Sim' : 'Não' }}
                </div>
                <input *ngIf="isEditing" 
                       type="checkbox" 
                       [checked]="editData?.staff?.hasDisability || false" 
                       (change)="updateField('staff', 'hasDisability', getCheckboxValue($event))">
              </div>
            </div>
          </div>
          
          <!-- Botões de Navegação -->
          <div class="navigation-buttons">
            <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
              <i class="fas fa-arrow-left"></i>
              Voltar
            </button>

            <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
              Próximo
              <i class="fas fa-arrow-right"></i>
            </button>

            <button class="btn btn-success" (click)="saveChanges()" *ngIf="isEditing" [disabled]="saving || !isTabValid(activeTab)">
              <i class="fas fa-save"></i>
              {{ saving ? 'Salvando...' : 'Salvar Alterações' }}
            </button>
          </div>
        </div>

        <!-- Aba: Endereços -->
        <div *ngIf="activeTab === 'addresses'" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-map-marker-alt"></i> Endereços</h3>
            
            <div *ngFor="let address of getAddressesForDisplay(); let i = index" class="address-item">
              <div class="address-header">
                <span class="address-type">{{ getAddressDisplayValue(address, 'type') }}</span>
                <span *ngIf="getAddressDisplayValue(address, 'isDefault') === 'Sim'" class="default-badge">Padrão</span>
                <button *ngIf="isEditing && i > 0" 
                        class="btn btn-danger btn-sm" 
                        (click)="removeItem('addresses', i)" 
                        type="button">
                  <i class="fas fa-trash"></i>
                  Remover
                </button>
              </div>

              <div class="detail-grid">
                <div class="detail-item">
                  <label>Tipo de Endereço:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getAddressDisplayValue(address, 'type') }}
                  </div>
                  <select *ngIf="isEditing" 
                          [value]="getAddressEditValue(address, 'type')" 
                          (change)="updateField('addresses', 'addressType', getSelectValue($event), i)" 
                          class="edit-select">
                    <option value="Residencial">Residencial</option>
                    <option value="Comercial">Comercial</option>
                    <option value="Correspondência">Correspondência</option>
                  </select>
                </div>
                <div class="detail-item">
                  <label>Rua:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getAddressDisplayValue(address, 'street') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="getAddressEditValue(address, 'street')" 
                         (input)="updateField('addresses', 'street', getInputValue($event), i)" 
                         class="edit-input" 
                         placeholder="Digite o nome da rua">
                </div>
                <div class="detail-item">
                  <label>Número:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getAddressDisplayValue(address, 'number') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="getAddressEditValue(address, 'number')" 
                         (input)="updateField('addresses', 'number', getInputValue($event), i)" 
                         class="edit-input" 
                         placeholder="Digite o número">
                </div>
                <div class="detail-item">
                  <label>Complemento:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getAddressDisplayValue(address, 'complement') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="getAddressEditValue(address, 'complement')" 
                         (input)="updateField('addresses', 'complement', getInputValue($event), i)" 
                         class="edit-input" 
                         placeholder="Complemento (opcional)">
                </div>
                <div class="detail-item">
                  <label>Bairro:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getAddressDisplayValue(address, 'neighborhood') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="getAddressEditValue(address, 'neighborhood')" 
                         (input)="updateField('addresses', 'neighborhood', getInputValue($event), i)" 
                         class="edit-input" 
                         placeholder="Digite o bairro">
                </div>
                <div class="detail-item">
                  <label>Cidade:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getAddressDisplayValue(address, 'city') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="getAddressEditValue(address, 'city')" 
                         (input)="updateField('addresses', 'city', getInputValue($event), i)" 
                         class="edit-input" 
                         placeholder="Digite a cidade">
                </div>
                <div class="detail-item">
                  <label>Estado:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getAddressDisplayValue(address, 'state') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="getAddressEditValue(address, 'state')" 
                         (input)="updateField('addresses', 'state', getInputValue($event), i)" 
                         class="edit-input" 
                         placeholder="Digite o estado">
                </div>
                <div class="detail-item">
                  <label>CEP:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ applyCepMask(getAddressDisplayValue(address, 'zipCode')) }}
                  </div>
                  <div *ngIf="isEditing" class="cep-input-group">
                    <input type="text" 
                           [value]="applyCepMask(getAddressEditValue(address, 'zipCode'))" 
                           (input)="updateField('addresses', 'zipCode', removeCepMask(getInputValue($event)), i)" 
                           class="edit-input cep-input" 
                           placeholder="00000-000"
                           maxlength="9">
                    <button type="button" 
                            class="btn btn-outline-primary btn-sm cep-button"
                            (click)="consultarCEP(removeCepMask(getAddressEditValue(address, 'zipCode')), i)"
                            title="Consultar CEP automaticamente">
                      <i class="fas fa-search"></i>
                      CEP
                    </button>
                  </div>
                </div>
                <div class="detail-item">
                  <label>País:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getAddressDisplayValue(address, 'country') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="getAddressEditValue(address, 'country')" 
                         (input)="updateField('addresses', 'country', getInputValue($event), i)" 
                         class="edit-input" 
                         placeholder="Digite o país">
                </div>
                <div class="detail-item">
                  <label>Endereço Padrão:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getAddressDisplayValue(address, 'isDefault') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="checkbox" 
                         [checked]="getAddressEditValue(address, 'isDefault')" 
                         (change)="updateField('addresses', 'isDefault', getCheckboxValue($event), i)">
                </div>
              </div>
            </div>

            <div class="address-actions" *ngIf="isEditing">
              <button class="btn btn-secondary" (click)="addNewItem('addresses')" type="button">
                <i class="fas fa-plus"></i>
                Adicionar Outro Endereço
              </button>
            </div>
          </div>
          
          <!-- Botões de Navegação -->
          <div class="navigation-buttons">
            <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
              <i class="fas fa-arrow-left"></i>
              Voltar
            </button>

            <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
              Próximo
              <i class="fas fa-arrow-right"></i>
            </button>

            <button class="btn btn-success" (click)="saveChanges()" *ngIf="isEditing" [disabled]="saving || !isTabValid(activeTab)">
              <i class="fas fa-save"></i>
              {{ saving ? 'Salvando...' : 'Salvar Alterações' }}
            </button>
          </div>
        </div>

        <!-- Aba: Dados Bancários -->
        <div *ngIf="activeTab === 'banking'" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-university"></i> Dados Bancários</h3>
            
            <div class="banking-item">
              <div class="banking-header">
                <h4>Conta Bancária</h4>
              </div>
              
              <div class="detail-grid">
                <div class="detail-item">
                  <label>Banco:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getBankingDisplayValue('bankName') }}
                  </div>
                  <select *ngIf="isEditing" 
                          [value]="editData?.staff?.bankName || ''" 
                          (change)="updateField('staff', 'bankName', getSelectValue($event))"
                          required>
                    <option value="">Selecione o banco</option>
                    <option *ngFor="let bank of BANKS_OPTIONS" 
                            [value]="bank.value">
                      {{ bank.label }}
                    </option>
                  </select>
                </div>
                
                <div class="detail-item">
                  <label>Agência:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getBankingDisplayValue('agency') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="editData?.staff?.agency || ''" 
                         (input)="updateField('staff', 'agency', getInputValue($event))"
                         placeholder="Ex: 1234" 
                         maxlength="10"
                         required>
                </div>

                <div class="detail-item">
                  <label>Tipo de Conta:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getBankingDisplayValue('accountType') }}
                  </div>
                  <select *ngIf="isEditing" 
                          [value]="editData?.staff?.accountType || ''" 
                          (change)="updateField('staff', 'accountType', getSelectValue($event))"
                          required>
                    <option value="">Selecione o tipo</option>
                    <option *ngFor="let type of ACCOUNT_TYPE_OPTIONS" 
                            [value]="type.value">
                      {{ type.label }}
                    </option>
                  </select>
                </div>
                
                <div class="detail-item">
                  <label>Número da Conta:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getBankingDisplayValue('accountNumber') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="editData?.staff?.accountNumber || ''" 
                         (input)="updateField('staff', 'accountNumber', getInputValue($event))"
                         placeholder="Ex: 12345-6" 
                         maxlength="20"
                         required>
                </div>
                
                <div class="detail-item">
                  <label>Nome do Titular:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getBankingDisplayValue('accountHolderName') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="editData?.staff?.accountHolderName || ''" 
                         (input)="updateField('staff', 'accountHolderName', getInputValue($event))"
                         placeholder="Nome completo do titular"
                         maxlength="200">
                </div>

                <div class="detail-item">
                  <label>Chave PIX:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getBankingDisplayValue('pixKey') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="editData?.staff?.pixKey || ''" 
                         (input)="updateField('staff', 'pixKey', getInputValue($event))"
                         placeholder="CPF, email, telefone ou chave aleatória"
                         maxlength="100">
                </div>
              </div>
            </div>

            <!-- Dados bancários são únicos por funcionário -->
          </div>
          
          <!-- Botões de Navegação -->
          <div class="navigation-buttons">
            <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
              <i class="fas fa-arrow-left"></i>
              Voltar
            </button>

            <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
              Próximo
              <i class="fas fa-arrow-right"></i>
            </button>

            <button class="btn btn-success" (click)="saveChanges()" *ngIf="isEditing" [disabled]="saving || !isTabValid(activeTab)">
              <i class="fas fa-save"></i>
              {{ saving ? 'Salvando...' : 'Salvar Alterações' }}
            </button>
          </div>
        </div>

        <!-- Aba: Contatos -->
        <div *ngIf="activeTab === 'contacts'" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-phone"></i> Contatos <span class="contact-counter">({{ getContactsForDisplay().length }} contatos)</span></h3>
            
            <div *ngFor="let contact of getContactsForDisplay(); let i = index" class="contact-item">
              <div class="contact-header">
                <span class="contact-type">{{ getContactDisplayValue(contact, 'contactType') }}</span>
                <span class="contact-relationship">{{ getContactDisplayValue(contact, 'relationship') }}</span>
                <span *ngIf="getContactDisplayValue(contact, 'isEmergencyContact') === 'Sim'" class="emergency-badge">Emergência</span>
                <span *ngIf="getContactDisplayValue(contact, 'isDefault') === 'Sim'" class="default-badge">Padrão</span>
                <button *ngIf="isEditing && i > 0" 
                        class="btn btn-danger btn-sm" 
                        (click)="removeItem('contacts', i)" 
                        type="button">
                  <i class="fas fa-trash"></i>
                  Remover
                </button>
              </div>

              <div class="detail-grid">
                <div class="detail-item">
                  <label>Tipo de Contato:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getContactDisplayValue(contact, 'contactType') }}
                  </div>
                  <select *ngIf="isEditing" 
                          [value]="contact.contactType || 'Telefone'" 
                          (change)="updateField('contacts', 'contactType', getSelectValue($event), i)" 
                          class="edit-select">
                    <option value="Telefone">Telefone</option>
                    <option value="Email">Email</option>
                    <option value="WhatsApp">WhatsApp</option>
                  </select>
                </div>
                <div class="detail-item">
                  <label>Nome/Valor:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getContactDisplayValue(contact, 'contactName') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="contact.contactName || ''" 
                         (input)="updateField('contacts', 'contactName', getInputValue($event), i)" 
                         class="edit-input" 
                         placeholder="Nome ou valor do contato">
                </div>
                <div class="detail-item">
                  <label>Telefone:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getContactDisplayValue(contact, 'phoneNumber') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="text" 
                         [value]="contact.phoneNumber || ''" 
                         (input)="updateField('contacts', 'phoneNumber', getInputValue($event), i)" 
                         class="edit-input" 
                         placeholder="Telefone">
                </div>
                <div class="detail-item">
                  <label>Relacionamento:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getContactDisplayValue(contact, 'relationship') }}
                  </div>
                  <select *ngIf="isEditing" 
                          [value]="contact.relationship || 'Próprio'" 
                          (change)="updateField('contacts', 'relationship', getSelectValue($event), i)" 
                          class="edit-select">
                    <option value="Próprio">Próprio</option>
                    <option value="Familiar">Familiar</option>
                    <option value="Amigo">Amigo</option>
                    <option value="Trabalho">Trabalho</option>
                  </select>
                </div>
                <div class="detail-item">
                  <label>Contato de Emergência:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getContactDisplayValue(contact, 'isEmergencyContact') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="checkbox" 
                         [checked]="contact.isEmergencyContact || false" 
                         (change)="updateField('contacts', 'isEmergencyContact', getCheckboxValue($event), i)" 
                         [disabled]="i < 1">
                  <small class="text-muted" *ngIf="i < 1">(Automático baseado na posição)</small>
                  <small class="text-muted" *ngIf="i >= 1">(Escolha se é contato de emergência)</small>
                </div>
                <div class="detail-item">
                  <label>Contato Padrão:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getContactDisplayValue(contact, 'isDefault') }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="checkbox" 
                         [checked]="contact.isDefault || false" 
                         (change)="updateField('contacts', 'isDefault', getCheckboxValue($event), i)" 
                         [disabled]="i < 1">
                  <small class="text-muted" *ngIf="i < 1">(Automático para o 1º contato)</small>
                  <small class="text-muted" *ngIf="i >= 1">(Escolha se é contato padrão)</small>
                </div>
              </div>
            </div>

            <div class="add-button-container" *ngIf="isEditing">
              <button type="button" 
                      class="btn btn-outline-primary" 
                      (click)="addNewItem('contacts')">
                <i class="fas fa-plus"></i>
                Adicionar Outro Contato
              </button>
            </div>
          </div>
          
          <!-- Botões de Navegação -->
          <div class="navigation-buttons">
            <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
              <i class="fas fa-arrow-left"></i>
              Voltar
            </button>

            <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
              Próximo
              <i class="fas fa-arrow-right"></i>
            </button>

            <button class="btn btn-success" (click)="saveChanges()" *ngIf="isEditing" [disabled]="saving || !isTabValid(activeTab)">
              <i class="fas fa-save"></i>
              {{ saving ? 'Salvando...' : 'Salvar Alterações' }}
            </button>
          </div>
        </div>

        <!-- Aba: Contrato -->
        <div *ngIf="activeTab === 'contract'" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-file-contract"></i> Informações do Contrato</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <label>Matrícula:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.Registration || '-' }}
                </div>
                <input *ngIf="isEditing" 
                       type="text" 
                       [value]="editData?.staff?.registration || ''" 
                       (input)="updateField('staff', 'registration', getInputValue($event))" 
                       class="edit-input" 
                       placeholder="Digite a matrícula" 
                       required>
              </div>
              <div class="detail-item">
                <label>Departamento <span style="color: red;">*</span>:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.Department || '-' }}
                </div>
                <select *ngIf="isEditing && editData && editData.staff" 
                        [(ngModel)]="editData.staff.department"
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="onDepartmentChange($event)"
                        class="edit-select" 
                        required>
                  <option value="">Selecione o departamento</option>
                  <option *ngFor="let dept of departments" [value]="dept.name">
                    {{ dept.name }}
                  </option>
                </select>
                <small class="form-text text-muted" *ngIf="isLoadingDepartments">
                  Carregando departamentos...
                </small>
              </div>
              <div class="detail-item">
                <label>Gerente:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.Manager || '-' }}
                </div>
                <input *ngIf="isEditing && editData && editData.staff" 
                       type="text" 
                       [(ngModel)]="editData.staff.manager"
                       [ngModelOptions]="{standalone: true}"
                       class="edit-input" 
                       placeholder="Preenchido automaticamente"
                       [readonly]="true"
                       style="background-color: #e9ecef;">
                <small class="form-text text-muted" *ngIf="isEditing && editData?.staff?.manager">
                  Gerente do departamento selecionado
                </small>
              </div>
              <div class="detail-item">
                <label>Cargo <span style="color: red;">*</span>:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.Position || '-' }}
                </div>
                <select *ngIf="isEditing && editData && editData.staff" 
                         [(ngModel)]="editData.staff.position"
                        [ngModelOptions]="{standalone: true}"
                        class="edit-select" 
                        [disabled]="!selectedDepartmentId || isLoadingPositions"
                        required>
                  <option value="">Selecione o cargo</option>
                  <option *ngFor="let position of positions" [value]="position.name">
                    {{ position.name }}<span *ngIf="position.level"> - {{ position.level }}</span>
                  </option>
                </select>
                <small class="form-text text-muted" *ngIf="isEditing && !selectedDepartmentId">
                  Selecione um departamento primeiro
                </small>
                <small class="form-text text-muted" *ngIf="isEditing && selectedDepartmentId && isLoadingPositions">
                  Carregando cargos...
                </small>
                <small class="form-text text-muted" *ngIf="isEditing && selectedDepartmentId && !isLoadingPositions && positions.length === 0">
                  Nenhum cargo cadastrado neste departamento
                </small>
              </div>
              <div class="detail-item">
                <label>Data de Admissão:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ formatDate(staffComplete?.Staff?.HireDate || null) }}
                </div>
                <input *ngIf="isEditing" 
                       type="date" 
                       [value]="getContractStartDateForInput()" 
                       (change)="updateField('staff', 'hireDate', getInputValue($event))" 
                       class="edit-input">
              </div>

              <div class="detail-item">
                <label>Unidade:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ staffComplete?.Staff?.Unit || '-' }}
                </div>
                <select *ngIf="isEditing && editData && editData.staff"
                        [(ngModel)]="editData.staff.unit"
                        [ngModelOptions]="{standalone: true}"
                        class="edit-select">
                  <option value="">Selecione a unidade</option>
                  <option *ngFor="let unit of UNIT_OPTIONS" [value]="unit.value">
                    {{ unit.label }}
                  </option>
                </select>
              </div>
              <div class="detail-item">
                <label>Tipo de Contrato:</label>
                  <div *ngIf="!isEditing" class="readonly-value">
                    {{ getContractDisplayValue('contractType') }}
                  </div>
                <select *ngIf="isEditing" 
                        [value]="editData?.contract?.contractType || 'CLT'" 
                        (change)="updateField('contract', 'contractType', getSelectValue($event))" 
                        class="edit-select">
                  <option value="CLT">CLT</option>
                  <option value="PJ">PJ</option>
                  <option value="Estagiário">Estagiário</option>
                  <option value="Temporário">Temporário</option>
                </select>
              </div>

              <!-- Dados da Empresa (PJ) - Aparecem apenas quando tipo de contrato é PJ -->
              <div *ngIf="staffComplete?.Staff?.ContractType === 'PJ' || editData?.contract?.contractType === 'PJ'" 
                   class="company-section" 
                   style="grid-column: 1 / -1; margin-top: 20px; padding-top: 20px; border-top: 2px solid #dee2e6;">
                <h4 style="margin-bottom: 15px; color: #495057;">
                  <i class="fas fa-building"></i> Dados da Empresa (Prestador de Serviço)
                </h4>
                
                <div class="detail-grid">
                  <!-- CNPJ -->
                  <div class="detail-item">
                    <label>CNPJ:</label>
                    <div *ngIf="!isEditing" class="view-value">
                      {{ staffComplete?.Staff?.CNPJ || editData?.contract?.cnpj || 'N/A' }}
                    </div>
                    <input *ngIf="isEditing" 
                           type="text" 
                           [ngModel]="editData?.contract?.cnpj || ''" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateField('contract', 'cnpj', $event)" 
                           class="edit-input" 
                           placeholder="00.000.000/0000-00" 
                           maxlength="18">
                  </div>
                  
                  <!-- Razão Social -->
                  <div class="detail-item full-width">
                    <label>Razão Social:</label>
                    <div *ngIf="!isEditing" class="view-value">
                      {{ staffComplete?.Staff?.CompanyName || editData?.contract?.companyName || 'N/A' }}
                    </div>
                    <input *ngIf="isEditing" 
                           type="text" 
                           [ngModel]="editData?.contract?.companyName || ''" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateField('contract', 'companyName', $event)" 
                           class="edit-input" 
                           placeholder="Nome completo da empresa">
                  </div>
                  
                  <!-- Nome Fantasia -->
                  <div class="detail-item full-width">
                    <label>Nome Fantasia:</label>
                    <div *ngIf="!isEditing" class="view-value">
                      {{ staffComplete?.Staff?.TradeName || editData?.contract?.tradeName || 'N/A' }}
                    </div>
                    <input *ngIf="isEditing" 
                           type="text" 
                           [ngModel]="editData?.contract?.tradeName || ''" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateField('contract', 'tradeName', $event)" 
                           class="edit-input" 
                           placeholder="Nome fantasia da empresa (opcional)">
                  </div>
                  
                  <!-- Endereço da Empresa -->
                  <div class="detail-item full-width">
                    <label>Endereço da Empresa:</label>
                    <div *ngIf="!isEditing" class="view-value">
                      {{ staffComplete?.Staff?.CompanyAddress || editData?.contract?.companyAddress || 'N/A' }}
                    </div>
                    <input *ngIf="isEditing" 
                           type="text" 
                           [ngModel]="editData?.contract?.companyAddress || ''" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateField('contract', 'companyAddress', $event)" 
                           class="edit-input" 
                           placeholder="Endereço completo da empresa (opcional)">
                  </div>
                  
                  <!-- Inscrição Estadual -->
                  <div class="detail-item">
                    <label>Inscrição Estadual:</label>
                    <div *ngIf="!isEditing" class="view-value">
                      {{ staffComplete?.Staff?.StateRegistration || editData?.contract?.stateRegistration || 'N/A' }}
                    </div>
                    <input *ngIf="isEditing" 
                           type="text" 
                           [ngModel]="editData?.contract?.stateRegistration || ''" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateField('contract', 'stateRegistration', $event)" 
                           class="edit-input" 
                           placeholder="Inscrição estadual (opcional)">
                  </div>
                  
                  <!-- Inscrição Municipal -->
                  <div class="detail-item">
                    <label>Inscrição Municipal:</label>
                    <div *ngIf="!isEditing" class="view-value">
                      {{ staffComplete?.Staff?.MunicipalRegistration || editData?.contract?.municipalRegistration || 'N/A' }}
                    </div>
                    <input *ngIf="isEditing" 
                           type="text" 
                           [ngModel]="editData?.contract?.municipalRegistration || ''" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateField('contract', 'municipalRegistration', $event)" 
                           class="edit-input" 
                           placeholder="Inscrição municipal (opcional)">
                  </div>
                  
                  <!-- Email da Empresa -->
                  <div class="detail-item">
                    <label>Email da Empresa:</label>
                    <div *ngIf="!isEditing" class="view-value">
                      {{ staffComplete?.Staff?.CompanyEmail || editData?.contract?.companyEmail || 'N/A' }}
                    </div>
                    <input *ngIf="isEditing" 
                           type="email" 
                           [ngModel]="editData?.contract?.companyEmail || ''" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateField('contract', 'companyEmail', $event)" 
                           class="edit-input" 
                           placeholder="email@empresa.com.br (opcional)">
                  </div>
                  
                  <!-- Telefone da Empresa -->
                  <div class="detail-item">
                    <label>Telefone da Empresa:</label>
                    <div *ngIf="!isEditing" class="view-value">
                      {{ staffComplete?.Staff?.CompanyPhone || editData?.contract?.companyPhone || 'N/A' }}
                    </div>
                    <input *ngIf="isEditing" 
                           type="text" 
                           [ngModel]="editData?.contract?.companyPhone || ''" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateField('contract', 'companyPhone', $event)" 
                           class="edit-input" 
                           placeholder="(00) 0000-0000 (opcional)">
                  </div>
                </div>
              </div>

              <div class="detail-item">
                <label>Centro de Custo:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ getCostCenterDisplay() }}
                </div>
                <select *ngIf="isEditing && editData && editData.contract"
                        [(ngModel)]="editData.contract.costCenter"
                        [ngModelOptions]="{standalone: true}"
                        class="edit-select">
                  <option value="">Selecione o centro de custo</option>
                  <option *ngFor="let cc of costCenters" [value]="cc.code">
                    {{ cc.code }} - {{ cc.name }}
                  </option>
                </select>
                <small class="form-text text-muted" *ngIf="isLoadingCostCenters">
                  Carregando centros de custo...
                </small>
              </div>

              <div class="detail-item">
                <label>Turno:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ getContractDisplayValue('shift') }}
                </div>
                <select *ngIf="isEditing" 
                        [value]="editData?.staff?.shift || 'Diurno'" 
                        (change)="onShiftChange(getSelectValue($event))" 
                        class="edit-select">
                  <option *ngFor="let shift of SHIFT_OPTIONS" [value]="shift.value">{{ shift.label }}</option>
                </select>
              </div>
              <div class="detail-item">
                <label>Horário de Trabalho:</label>
                <div *ngIf="!isEditing" class="readonly-value">
                  {{ getWorkScheduleDisplay() }}
                </div>
                <div *ngIf="isEditing" class="work-schedule-editor">
                  <select [value]="getWorkStartTime()" 
                          (change)="onWorkStartChange(getSelectValue($event))" 
                          class="edit-select">
                    <option *ngFor="let startTime of WORK_START_OPTIONS" [value]="startTime.value">{{ startTime.value }}</option>
                  </select>
                  <span class="work-schedule-info mx-2">até</span>
                  <select [value]="getWorkEndTime()" 
                          (change)="onWorkEndChange(getSelectValue($event))" 
                          class="edit-select">
                    <option *ngFor="let endTime of WORK_START_OPTIONS" [value]="endTime.value">{{ endTime.value }}</option>
                  </select>
                  <span class="work-schedule-info ms-3">
                    {{ getWorkStartTime() }} → {{ getWorkEndTime() }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Botões de Navegação -->
          <div class="navigation-buttons">
            <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
              <i class="fas fa-arrow-left"></i>
              Voltar
            </button>

            <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
              Próximo
              <i class="fas fa-arrow-right"></i>
            </button>

            <button class="btn btn-success" (click)="saveChanges()" *ngIf="isEditing" [disabled]="saving || !isTabValid(activeTab)">
              <i class="fas fa-save"></i>
              {{ saving ? 'Salvando...' : 'Salvar Alterações' }}
            </button>
          </div>
        </div>

        <!-- Aba: Salário -->
        <div *ngIf="activeTab === 'salary'" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-money-bill-wave"></i> Dados Salariais</h3>
            <div class="detail-grid">
              <div class="detail-item">
                <label>Salário Base:</label>
                <div *ngIf="!isEditing" class="view-value">
                  {{ formatCurrency(getSalaryBase()) }}
                </div>
                <input *ngIf="isEditing" 
                       type="number" 
                       [ngModel]="getSalaryBase()" 
                       [ngModelOptions]="{standalone: true}"
                       (ngModelChange)="updateField('salary', 'baseSalary', parseFloatValue($event))" 
                       class="edit-input" 
                       placeholder="0.00" 
                       step="0.01">
              </div>
              <div class="detail-item">
                <label>Salário Bruto:</label>
                <div *ngIf="!isEditing" class="view-value">
                  {{ formatCurrency(getSalaryGross()) }}
                </div>
                <input *ngIf="isEditing" 
                       type="number" 
                       [ngModel]="getSalaryGross()" 
                       [ngModelOptions]="{standalone: true}"
                       (ngModelChange)="updateField('salary', 'grossSalary', parseFloatValue($event))" 
                       class="edit-input" 
                       placeholder="0.00" 
                       step="0.01">
              </div>
              <div class="detail-item">
                <label>Salário Líquido:</label>
                <div *ngIf="!isEditing" class="view-value">
                  {{ formatCurrency(getSalaryNet()) }}
                </div>
                <input *ngIf="isEditing" 
                       type="number" 
                       [ngModel]="getSalaryNet()" 
                       [ngModelOptions]="{standalone: true}"
                       (ngModelChange)="updateField('salary', 'netSalary', parseFloatValue($event))" 
                       class="edit-input" 
                       placeholder="0.00" 
                       step="0.01">
              </div>
              <div class="detail-item">
                <label>Tipo de Salário:</label>
                <div *ngIf="!isEditing" class="view-value">
                  {{ getSalaryType() || 'N/A' }}
                </div>
                <select *ngIf="isEditing" 
                        [ngModel]="getSalaryType()" 
                        [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="updateField('salary', 'salaryType', $event)" 
                        class="edit-select">
                  <option value="Mensal">Mensal</option>
                  <option value="Por Hora">Por Hora</option>
                  <option value="Por Projeto">Por Projeto</option>
                  <option value="Comissão">Comissão</option>
                </select>
              </div>
              <div class="detail-item">
                <label>Observações:</label>
                <div *ngIf="!isEditing" class="view-value">
                  {{ getSalaryNotes() || 'N/A' }}
                </div>
                <textarea *ngIf="isEditing" 
                          [ngModel]="getSalaryNotes()" 
                          [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="updateField('salary', 'notes', $event)" 
                          class="edit-textarea" 
                          rows="3"></textarea>
              </div>
            </div>

            <!-- Histórico Salarial -->
            <div class="salary-history-section" *ngIf="staffComplete?.SalaryHistory?.length">
              <h4 style="margin-top: 24px; margin-bottom: 12px;">
                <i class="fas fa-history me-2"></i>
                Histórico Salarial
              </h4>
              <div class="table-responsive">
                <table class="documents-table">
                  <thead>
                    <tr>
                      <th>Vigente Desde</th>
                      <th>Até</th>
                      <th>Tipo</th>
                      <th class="text-end">Base</th>
                      <th class="text-end">Bruto</th>
                      <th class="text-end">Líquido</th>
                      <th>Status</th>
                      <th>Motivo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let s of getSortedSalaryHistory()">
                      <td>{{ s.EffectiveDate ? formatDate(s.EffectiveDate) : '-' }}</td>
                      <td>{{ s.EndDate ? formatDate(s.EndDate) : '-' }}</td>
                      <td>{{ mapEnumValue('salaryType', s.SalaryType || 'Mensal') }}</td>
                      <td class="text-end">{{ formatCurrency(s.BaseSalary || 0) }}</td>
                      <td class="text-end">{{ formatCurrency(s.GrossSalary || 0) }}</td>
                      <td class="text-end">{{ formatCurrency(s.NetSalary || 0) }}</td>
                      <td>
                        <span class="badge"
                              [ngClass]="s.IsCurrent ? 'bg-success' : 'bg-secondary'">
                          {{ s.IsCurrent ? 'Atual' : 'Histórico' }}
                        </span>
                      </td>
                      <td>{{ s.Reason || s.Notes || '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          
          <!-- Botões de Navegação -->
          <div class="navigation-buttons">
            <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
              <i class="fas fa-arrow-left"></i>
              Voltar
            </button>

            <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
              Próximo
              <i class="fas fa-arrow-right"></i>
            </button>

            <button class="btn btn-success" (click)="saveChanges()" *ngIf="isEditing" [disabled]="saving || !isTabValid(activeTab)">
              <i class="fas fa-save"></i>
              {{ saving ? 'Salvando...' : 'Salvar Alterações' }}
            </button>
          </div>
        </div>

        <!-- Aba: Benefícios -->
        <div *ngIf="activeTab === 'benefits'" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-gift"></i> Benefícios</h3>
            
            <div *ngIf="getBenefitsForDisplay().length === 0" class="no-benefits" style="text-align: center; padding: 40px; color: #6c757d;">
              <i class="fas fa-gift" style="font-size: 48px; margin-bottom: 20px; opacity: 0.3;"></i>
              <p>Nenhum benefício cadastrado para este funcionário.</p>
            </div>
            
            <div *ngFor="let benefit of getBenefitsForDisplay(); let i = index" class="benefit-item" style="margin-bottom: 20px; padding: 15px; border: 1px solid #dee2e6; border-radius: 8px;">
              <div class="benefit-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
                <h4 style="margin: 0;">Benefício {{ i + 1 }}</h4>
                <button *ngIf="isEditing && getBenefitsForDisplay().length > 1" 
                        type="button"
                        class="btn btn-danger btn-sm" 
                        (click)="removeBenefit(i)">
                  <i class="fas fa-trash"></i>
                  Remover
                </button>
              </div>

              <div class="detail-grid">
                <div class="detail-item">
                  <label>Tipo de Benefício <span style="color: red;">*</span>:</label>
                  <div *ngIf="!isEditing" class="view-value">
                    {{ benefit.benefitType || 'N/A' }}
                  </div>
                  <select *ngIf="isEditing" 
                          [ngModel]="benefit.benefitType || ''" 
                          [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="updateField('benefits', 'benefitType', $event, i)" 
                          class="edit-select" 
                          required>
                    <option value="">Selecione o tipo de benefício</option>
                    <option *ngFor="let option of BENEFIT_TYPE_OPTIONS" [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>
                
                <div class="detail-item">
                  <label>Valor (R$) <span style="color: red;">*</span>:</label>
                  <div *ngIf="!isEditing" class="view-value">
                    {{ formatCurrency(benefit.amount || 0) }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="number" 
                         [ngModel]="benefit.amount || 0" 
                         [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updateField('benefits', 'amount', parseFloatValue($event), i)" 
                         class="edit-input" 
                         placeholder="0.00" 
                         step="0.01"
                         min="0"
                         required>
                </div>
                
                <div class="detail-item">
                  <label>Data de Início:</label>
                  <div *ngIf="!isEditing" class="view-value">
                    {{ benefit.startDate ? formatDate(benefit.startDate) : 'N/A' }}
                  </div>
                  <input *ngIf="isEditing" 
                         type="date" 
                         [ngModel]="benefit.startDate ? (benefit.startDate.split('T')[0]) : ''"
                         [ngModelOptions]="{standalone: true}"
                         (ngModelChange)="updateField('benefits', 'startDate', $event + 'T00:00:00.000Z', i)" 
                         class="edit-input">
                </div>
                
                <div class="detail-item">
                  <label>Status:</label>
                  <div *ngIf="!isEditing" class="view-value">
                    <span [style.color]="(benefit.isActive ?? true) ? '#28a745' : '#dc3545'">
                      <i class="fas" [class.fa-check-circle]="(benefit.isActive ?? true)" [class.fa-times-circle]="!(benefit.isActive ?? true)"></i>
                      {{ (benefit.isActive ?? true) ? 'Ativo' : 'Inativo' }}
                    </span>
                  </div>
                  <div *ngIf="isEditing" style="display: flex; align-items: center; gap: 10px;">
                    <input type="checkbox" 
                           [ngModel]="benefit.isActive ?? true" 
                           [ngModelOptions]="{standalone: true}"
                           (ngModelChange)="updateField('benefits', 'isActive', $event, i)" 
                           [id]="'benefitActive' + i">
                    <label [for]="'benefitActive' + i" style="margin: 0; font-weight: normal;">
                      Benefício ativo
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="add-button-container" style="margin-top: 20px;" *ngIf="isEditing">
              <button type="button" 
                      class="btn btn-outline-primary" 
                      (click)="addBenefit()">
                <i class="fas fa-plus"></i>
                Adicionar Outro Benefício
              </button>
            </div>
          </div>
          
          <!-- Botões de Navegação -->
          <div class="navigation-buttons">
            <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
              <i class="fas fa-arrow-left"></i>
              Voltar
            </button>

            <button class="btn btn-primary" (click)="goToNextTab()" *ngIf="!isLastTab()" [disabled]="!isTabValid(activeTab)">
              Próximo
              <i class="fas fa-arrow-right"></i>
            </button>

            <button class="btn btn-success" (click)="saveChanges()" *ngIf="isEditing" [disabled]="saving || !isTabValid(activeTab)">
              <i class="fas fa-save"></i>
              {{ saving ? 'Salvando...' : 'Salvar Alterações' }}
            </button>
          </div>
        </div>

        <!-- Aba: Documentos -->
        <div *ngIf="activeTab === 'documents'" class="tab-panel">
          <div class="detail-section">
            <h3><i class="fas fa-paperclip"></i> Documentos e Anexos</h3>
            
            <!-- Modo de Visualização: Exibir documentos existentes em TABELA -->
            <div *ngIf="!isEditing" class="existing-documents">
              <h4>Documentos Existentes</h4>
              
              <div *ngIf="(staffComplete?.Attachments?.length || 0) > 0; else noDocuments">
                <table class="documents-table">
                  <thead>
                    <tr>
                      <th style="width: 40px;"></th>
                      <th>Nome do Documento</th>
                      <th>Tamanho</th>
                      <th>Extensão</th>
                      <th>Status</th>
                      <th>Data de Criação</th>
                      <th style="width: 120px;">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let attachment of (staffComplete?.Attachments || [])">
                      <td class="icon-cell">
                        <i class="fas fa-file" *ngIf="!isImageFile(attachment?.FileExtension || '')"></i>
                        <i class="fas fa-image" *ngIf="isImageFile(attachment?.FileExtension || '')"></i>
                      </td>
                      <td>{{ attachment?.DocumentName || 'Documento sem nome' }}</td>
                      <td>{{ attachment?.FileSizeFormatted || formatFileSize(attachment?.FileSize) || '-' }}</td>
                      <td>{{ (attachment?.FileExtension || '').toUpperCase() }}</td>
                      <td>
                        <span class="status-badge" [class]="'status-' + normalizeDocumentStatus(attachment?.Status).toLowerCase()">
                          {{ normalizeDocumentStatus(attachment?.Status) }}
                        </span>
                      </td>
                      <td>{{ attachment?.CreatedAt ? formatDate(attachment.CreatedAt) : '-' }}</td>
                      <td class="actions-cell">
                        <button class="btn btn-primary btn-sm" 
                                (click)="downloadDocument(attachment)"
                                title="Baixar documento">
                          <i class="fas fa-download"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <ng-template #noDocuments>
                <div class="no-documents">
                  <i class="fas fa-inbox"></i>
                  <p>Nenhum documento encontrado para este funcionário.</p>
                </div>
              </ng-template>
            </div>

            <!-- Modo de Edição: Tabela completa de tipos de documentos -->
            <div *ngIf="isEditing">
              <h4>Gerenciar Documentos</h4>
              
              <!-- Tabela com todos os tipos de documentos -->
              <table class="documents-table">
                <thead>
                  <tr>
                    <th style="width: 40px;"></th>
                    <th>Tipo de Documento</th>
                    <th>Nome do Documento</th>
                    <th>Arquivo</th>
                    <th>Status</th>
                    <th>Tamanho</th>
                    <th style="width: 180px;">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let docType of DOCUMENT_TYPES; let i = index">
                    <td class="icon-cell">
                      <i [class]="docType.icon"></i>
                    </td>
                    <td>
                      <span>{{ docType.label }}</span>
                      <!-- Check verde se o documento já existe -->
                      <i *ngIf="hasExistingDocument(docType.value)" 
                         class="fas fa-check-circle" 
                         style="color: #28a745; margin-left: 8px;" 
                         title="Documento já cadastrado"></i>
                    </td>
                    <td>
                      <!-- Se documento existe, mostra o nome -->
                      <span *ngIf="hasExistingDocument(docType.value)">
                        {{ getExistingDocumentName(docType.value) }}
                      </span>
                      <!-- Se não existe mas tem arquivo selecionado -->
                      <span *ngIf="!hasExistingDocument(docType.value) && uploadedDocuments[docType.value]">
                        {{ uploadedDocuments[docType.value]?.documentName || docType.label }}
                      </span>
                      <!-- Se não existe e não tem arquivo selecionado -->
                      <span *ngIf="!hasExistingDocument(docType.value) && !uploadedDocuments[docType.value]" style="color: #6c757d;">
                        -
                      </span>
                    </td>
                    <td>
                      <input type="file" 
                             [id]="'file-' + docType.value"
                             [accept]="docType.value === 'photo' ? 'image/*' : '*/*'"
                             (change)="onFileSelected($event, docType.value)"
                             style="display: none;">
                      
                      <!-- Se documento já existe -->
                      <span *ngIf="hasExistingDocument(docType.value)" style="color: #28a745;">
                        <i class="fas fa-file-alt"></i> Cadastrado
                      </span>
                      <!-- Se não tem arquivo selecionado -->
                      <span *ngIf="!hasExistingDocument(docType.value) && !uploadedDocuments[docType.value]" style="color: #6c757d;">
                        -
                      </span>
                      <!-- Se tem arquivo selecionado mas não enviado -->
                      <span *ngIf="!hasExistingDocument(docType.value) && uploadedDocuments[docType.value] && !uploadedDocuments[docType.value].uploaded">
                        {{ getFileName(docType.value) }}
                      </span>
                      <!-- Se arquivo foi enviado agora -->
                      <span *ngIf="!hasExistingDocument(docType.value) && uploadedDocuments[docType.value]?.uploaded" style="color: #28a745;">
                        {{ getFileName(docType.value) }}
                      </span>
                    </td>
                    <td>
                      <!-- Status baseado no estado do documento -->
                      <span *ngIf="hasExistingDocument(docType.value)" class="status-badge status-aprovado">
                        <i class="fas fa-check"></i> Cadastrado
                      </span>
                      <span *ngIf="!hasExistingDocument(docType.value) && !uploadedDocuments[docType.value]" class="status-badge status-pendente">
                        Pendente
                      </span>
                      <span *ngIf="!hasExistingDocument(docType.value) && uploadedDocuments[docType.value] && !uploadedDocuments[docType.value].uploaded && uploadStatus[docType.value] !== 'uploading'" class="status-badge status-selecionado">
                        Selecionado
                      </span>
                      <span *ngIf="uploadStatus[docType.value] === 'uploading'" class="status-badge status-enviando">
                        <i class="fas fa-spinner fa-spin"></i> Enviando...
                      </span>
                      <span *ngIf="!hasExistingDocument(docType.value) && uploadedDocuments[docType.value]?.uploaded" class="status-badge status-aprovado">
                        Enviado
                      </span>
                      <span *ngIf="uploadStatus[docType.value] === 'error'" class="status-badge status-rejeitado">
                        Erro
                      </span>
                    </td>
                    <td>
                      <!-- Tamanho do arquivo -->
                      <span *ngIf="hasExistingDocument(docType.value)">
                        {{ formatFileSize(getExistingDocumentSize(docType.value)) }}
                      </span>
                      <span *ngIf="!hasExistingDocument(docType.value) && uploadedDocuments[docType.value]">
                        {{ getFileSize(docType.value) }}
                      </span>
                      <span *ngIf="!hasExistingDocument(docType.value) && !uploadedDocuments[docType.value]">
                        -
                      </span>
                    </td>
                    <td class="actions-cell">
                      <!-- Documento já existe: Baixar e Remover -->
                      <button *ngIf="hasExistingDocument(docType.value)" 
                              class="btn btn-primary btn-sm"
                              (click)="downloadExistingDocument(docType.value)"
                              title="Baixar documento">
                        <i class="fas fa-download"></i>
                      </button>
                      <button *ngIf="hasExistingDocument(docType.value)" 
                              class="btn btn-danger btn-sm ml-1"
                              (click)="removeExistingDocument(docType.value)"
                              title="Remover documento">
                        <i class="fas fa-trash"></i>
                      </button>
                      
                      <!-- Documento não existe: Selecionar arquivo -->
                      <button *ngIf="!hasExistingDocument(docType.value) && !uploadedDocuments[docType.value]" 
                              type="button"
                              class="btn btn-primary btn-sm"
                              (click)="getDocumentElement().getElementById('file-' + docType.value)?.click()"
                              title="Selecionar arquivo">
                        <i class="fas fa-upload"></i>
                      </button>
                      
                      <!-- Arquivo selecionado: Adicionar e Alterar -->
                      <button *ngIf="!hasExistingDocument(docType.value) && uploadedDocuments[docType.value] && !uploadedDocuments[docType.value].uploaded" 
                              type="button"
                              class="btn btn-success btn-sm"
                              (click)="uploadDocumentToBackend(docType.value)"
                              [disabled]="uploadStatus[docType.value] === 'uploading'"
                              title="Adicionar documento">
                        <i class="fas fa-plus"></i>
                      </button>
                      <button *ngIf="!hasExistingDocument(docType.value) && uploadedDocuments[docType.value] && !uploadedDocuments[docType.value].uploaded" 
                              type="button"
                              class="btn btn-warning btn-sm ml-1"
                              (click)="getDocumentElement().getElementById('file-' + docType.value)?.click()"
                              title="Alterar arquivo">
                        <i class="fas fa-edit"></i>
                      </button>
                      
                      <!-- Arquivo enviado agora: Remover -->
                      <button *ngIf="!hasExistingDocument(docType.value) && uploadedDocuments[docType.value]?.uploaded" 
                              type="button"
                              class="btn btn-danger btn-sm"
                              (click)="deleteDocument(docType.value)"
                              title="Remover documento">
                        <i class="fas fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              
              <!-- Seção: Outros Documentos (Múltiplos) -->
              <div class="other-documents-section mt-4">
                <h5><i class="fas fa-folder-open"></i> Outros Documentos </h5>
                
                <!-- Tabela de documentos "outros" existentes -->
                <table class="documents-table" *ngIf="getExistingOtherDocuments().length > 0 || otherDocuments.length > 0">
                  <thead>
                    <tr>
                      <th style="width: 40px;"></th>
                      <th>Nome do Documento</th>
                      <th>Tamanho</th>
                      <th>Status</th>
                      <th style="width: 120px;">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Documentos "outros" já salvos no banco -->
                    <tr *ngFor="let attachment of getExistingOtherDocuments()">
                      <td class="icon-cell">
                        <i class="fas fa-file"></i>
                      </td>
                      <td>
                        {{ attachment.documentName || attachment.DocumentName }}
                        <i class="fas fa-check-circle" style="color: #28a745; margin-left: 8px;" title="Documento salvo"></i>
                      </td>
                      <td>{{ formatFileSizeOther(attachment.fileSize || attachment.FileSize) }}</td>
                      <td>
                        <span class="status-badge status-aprovado">
                          <i class="fas fa-check"></i> Cadastrado
                        </span>
                      </td>
                      <td class="actions-cell">
                        <button class="btn btn-primary btn-sm" 
                                (click)="downloadDocument(attachment)"
                                title="Baixar documento">
                          <i class="fas fa-download"></i>
                        </button>
                        <button class="btn btn-danger btn-sm ml-1" 
                                (click)="removeExistingOtherDocument(attachment)"
                                title="Remover documento">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                    
                    <!-- Documentos "outros" novos (pendentes de upload) -->
                    <tr *ngFor="let doc of otherDocuments; let i = index">
                      <td class="icon-cell">
                        <i class="fas fa-file-upload"></i>
                      </td>
                      <td>{{ doc.documentName }}</td>
                      <td>{{ formatFileSizeOther(doc.fileSize) }}</td>
                      <td>
                        <span *ngIf="doc.status === 'selecionado'" class="status-badge status-selecionado">
                          Selecionado
                        </span>
                        <span *ngIf="doc.status === 'enviando'" class="status-badge status-enviando">
                          <i class="fas fa-spinner fa-spin"></i> Enviando...
                        </span>
                        <span *ngIf="doc.status === 'enviado'" class="status-badge status-aprovado">
                          <i class="fas fa-check"></i> Enviado
                        </span>
                        <span *ngIf="doc.status === 'erro'" class="status-badge status-rejeitado">
                          Erro
                        </span>
                      </td>
                      <td class="actions-cell">
                        <button *ngIf="doc.status === 'selecionado'" 
                                class="btn btn-success btn-sm"
                                (click)="uploadOtherDocument(i)"
                                title="Enviar documento">
                          <i class="fas fa-upload"></i>
                        </button>
                        <button class="btn btn-danger btn-sm ml-1" 
                                (click)="removeOtherDocument(i)"
                                title="Remover documento">
                          <i class="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                
                <!-- Botão para adicionar mais documentos -->
                <div class="add-other-document mt-3">
                  <input type="file" 
                         id="other-document-input"
                         (change)="onOtherFileSelected($event)"
                         style="display: none;">
                  <button type="button" 
                          class="btn btn-outline-primary"
                          (click)="getDocumentElement().getElementById('other-document-input')?.click()">
                    <i class="fas fa-plus"></i> Adicionar Outro Documento
                  </button>
                </div>
              </div>
            </div>
            
            <!-- Botões de Navegação -->
            <div class="navigation-buttons">
              <button class="btn btn-secondary" (click)="goToPreviousTab()" [disabled]="isFirstTab()">
                <i class="fas fa-arrow-left"></i>
                Voltar
              </button>

              <button class="btn btn-success" (click)="saveChanges()" [disabled]="saving || !isTabValid(activeTab)">
                <i class="fas fa-save"></i>
                {{ saving ? 'Salvando...' : 'Salvar Alterações' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </app-form-shell>
    </div>
</app-side-menu>

